module.exports = __webpack_public_path__ + "img/aluminio.5be0feb9.jpg";